// Top-level error boundary. Without one, a single uncaught render error in ANY
// page component blanks the entire SPA (white screen). This catches it and shows
// a recoverable card — the top nav stays mounted (this wraps only the routed
// content), so the user can navigate away or reload. React requires a class for
// error boundaries (no hook equivalent).
import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, componentStack: "" };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // surface to the console for debugging; data is untouched (render-only failure).
    // Capture the React component stack so the crash NAMES the failing component
    // (with build keepNames the names are un-mangled) — an opaque "N is not a function"
    // is otherwise undiagnosable.
    console.error("Helm render error:", error, info);   // eslint-disable-line no-console
    this.setState({ componentStack: info?.componentStack || "" });
  }
  render() {
    if (this.state.error) {
      const e = this.state.error;
      const details = [String(e?.message || e), e?.stack || "", this.state.componentStack]
        .filter(Boolean).join("\n\n");
      return (
        <section className="panel" style={{ maxWidth: 580 }} data-testid="error-boundary">
          <div className="section-head"><h3>Something went wrong on this page</h3></div>
          <p className="muted">A display error occurred while rendering — your account and data are safe. Reload to recover, or head back to the Dashboard.</p>
          <p className="muted mono" style={{ fontSize: 12, wordBreak: "break-word" }}>
            {String(e?.message || e)}
          </p>
          <details style={{ marginTop: 8 }}>
            <summary className="muted" style={{ fontSize: 12, cursor: "pointer" }}>Technical details (for a bug report)</summary>
            <pre className="mono" data-testid="error-detail"
              style={{ fontSize: 11, whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: 220,
                       overflow: "auto", marginTop: 6, color: "var(--text-3)" }}>{details}</pre>
          </details>
          <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
            <button className="btn" onClick={() => window.location.reload()}>Reload</button>
            <a className="btn btn--ghost" href="/">Go to Dashboard</a>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}
